export enum Constants {
  SET_MODAL = 'SET_MODAL',
  SET_DISABLE = 'SET_DISABLE',
  SET_MULTIPLE_MODAL = 'SET_MULTIPLE_MODAL',
}

export enum ModalSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
  FIT = 'FIT',
}

export enum ModalType {
  DELETE = 'DELETE',
  FORM = 'FORM',
  BULK = 'BULK',
  PREVIEW = 'PREVIEW',
  FINDER = 'FINDER',
  DEMO = 'DEMO',
}

interface SetShowModal {
  type: typeof Constants.SET_MODAL,
  payload: ModalType | null,
  isClose?: boolean
}

interface SetDisableModal {
  type: typeof Constants.SET_DISABLE,
  payload: null
  disable?: boolean
}

interface SetMultipleModal {
  type: typeof Constants.SET_MULTIPLE_MODAL,
  payload: boolean
}

export type ModalActionTypes = SetShowModal
  | SetDisableModal | SetMultipleModal

export interface IModalState {
  type: ModalType | null
  disable: boolean | null
  multiple: boolean
}
